import React, { useState } from 'react'
import * as API from '../../utility/api'
import BasketBox from './basket-box'

const Baskets = ({ baskets, onReleased }) => {
  const sortedBaskets = []
  console.log('baskets', baskets)
  for(const basket of baskets) {
    if(basket.payments && basket.payments.length > 0) {
      basket.payments.sort((a,b) => {
        const date1 = new Date(a.payed_at)
        const date2 = new Date(b.payed_at)
        return date1 - date2
      })
      basket.payment = basket.payments[0]
    } else {
      basket.payment = {}
    }
    sortedBaskets.push(basket)
  }

  return sortedBaskets.map(basket => (
    <BasketBox key={basket.id} {...basket} onReleased={onReleased} />
  ))
}

const BASKETS_URL = 'admin/orders'

const FindBaskets = () => {
  const [data, setData] = useState(null)
  const [reference, setReference] = useState('')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [tel, setTel] = useState('')
  const [eventId, setEventId] = useState('')
  const [paymentStatus, setPaymentStatus] = useState('')
  const [saleStatus, setSaleStatus] = useState('')
  const [stuckCheckout, setStuckCheckout] = useState(false)

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState([])

  const getData = () => {
    setLoading(true)

    API.GET(BASKETS_URL, {
      reference,
      code,
      name,
      email,
      tel,
      paymentStatus,
      eventId,
      ticketStatus: stuckCheckout ? 'FOR_SALE' : saleStatus,
      stuckCheckout: stuckCheckout ? 'true' : undefined
    })
      .then(({data}) => {
        console.log(data)
        setData(data.orders)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
        setError(['Tilausten hakeminen epäonnistui', ...error])
      })
  }

  const submitForm = e => {
    e.preventDefault()

    getData()
  }

  return (
    <div>
      <div>
        <h2>Etsi tilauksia</h2>

        <form onSubmit={submitForm}>
          <div
            className="management--form--box"
            style={{
              display: 'flex',
              flexFlow: 'column nowrap',
              alignItems: 'baseline'
            }}
          >
            <div>
              <h3>Ostoskorin tiedot</h3>
            </div>

            <p>Määrittele, millaisia tilauksia haluat hakea.</p>

            <div style={{ display: 'flex' }}>
              <div>
                <label>Lippukoodi</label>
                <input
                  type="text"
                  value={code}
                  onChange={e => setCode(e.target.value)}
                />
              </div>

              <div>
                <label>Checkout referenssi</label>
                <input
                  type="text"
                  value={reference}
                  onChange={e => setReference(e.target.value)}
                />
              </div>

              <div>
                <label>Tapahtuma ID</label>
                <input
                  type="number"
                  value={eventId}
                  onChange={e => setEventId(e.target.value)}
                />
              </div>
            </div>

            <div style={{ display: 'flex' }}>
              <div>
                <label>Maksun status</label>
                <select
                  value={paymentStatus}
                  onChange={e => setPaymentStatus(e.target.value)}
                >
                  <option value="" />
                  <option value="REJECTED">Hylätty</option>
                  <option value="PAID">Maksettu</option>
                  <option value="VERIFIED">Vahvistettu</option>
                  <option value="PENDING">Ei maksettu</option>
                  <option value="CANCELLED">Peruttu</option>
                  <option value="FAILED">Epäonnistunut</option>
                  <option value="REFUNDED">Hyvitetty</option>
                </select>
              </div>
              <div>
                <label>Lipun status</label>
                <select
                  value={stuckCheckout ? 'FOR_SALE' : saleStatus}
                  onChange={e => setSaleStatus(e.target.value)}
                  disabled={stuckCheckout}
                >
                  <option value="" />
                  <option value="EXPIRED">Vanhentunut</option>
                  <option value="REJECTED">Hylätty</option>
                  <option value="FOR_SALE">Myynnissä</option>
                  <option value="SOLD">Myyty</option>
                  <option value="FROZEN">Jäädytetty</option>
                  <option value="DELETED">Poistettu</option>
                  <option value="FAILED">Prosessiontivirhe</option>
                </select>
              </div>
              <div>
                <label>Checkout-tila</label>
                <select
                  value={stuckCheckout ? 'stuck' : ''}
                  onChange={e => setStuckCheckout(e.target.value === 'stuck')}
                >
                  <option value="" />
                  <option value="stuck">Kesken (lippu jumissa)</option>
                </select>
              </div>
            </div>

            <div>
              <h3>Käyttäjän tiedot</h3>
            </div>

            <p>
              Määrittele kenen tilauksia haluat hakea. Pelkkä checkout-suodatin
              riittää hakemaan jumissa olevat tilaukset, joiden lippu on yhä
              myynnissä.
            </p>

            <div style={{ display: 'flex' }}>
              <div>
                <label>Nimi</label>
                <input
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>

              <div>
                <label>Sähköposti</label>
                <input
                  type="text"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>

              <div>
                <label>Puhelinnumero</label>
                <input
                  type="number"
                  value={tel}
                  onChange={e => setTel(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="break-md" />

          <div>
            <button disabled={loading}>
              {loading ? 'haetaan tilausta' : 'etsi tilaus'}
            </button>
          </div>
        </form>
      </div>

      <div className="break-lg" />

      {data && (
        <div>
          <Baskets
            baskets={data}
            onReleased={id =>
              setData(current => current.filter(order => order.id !== id))
            }
          />
        </div>
      )}

      {data && data.length === 0 && <div>Tilauksia ei löytynyt</div>}
    </div>
  )
}

const BasketManagement = () => {
  return <div>{FindBaskets()}</div>
}

export default BasketManagement
